import { useEffect, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { clientPortalApi } from '../../api/client-portal';
import { getUserPermissions } from '../../api/auth';
import { isClientOnlyPortalUser } from '../../config/navigation';
import { AUTH_USER_CHANGED_EVENT } from '../../constants/auth-events';

/** True only for the main cabinet user. Branch logins do not get the accounts menu. */
export function usePortalMainNavFlag(): boolean {
  const queryClient = useQueryClient();
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const onChange = () => {
      void queryClient.removeQueries({ queryKey: ['client-portal-me'] });
      setTick((n) => n + 1);
    };
    window.addEventListener(AUTH_USER_CHANGED_EVENT, onChange);
    return () => window.removeEventListener(AUTH_USER_CHANGED_EVENT, onChange);
  }, [queryClient]);

  const enabled = isClientOnlyPortalUser(getUserPermissions());
  const meQ = useQuery({
    queryKey: ['client-portal-me'],
    queryFn: () => clientPortalApi.me(),
    enabled,
    staleTime: 30_000,
  });

  return tick >= 0 && enabled && meQ.data?.canManageAccounts === true;
}
